module.exports = __webpack_public_path__ + "static/media/eg5.5a4a0eef.webp";